import PropTracker from "../../../prop-trackers/prop-tracker.js";
import PropChainTracker from "../../../prop-tracker-utils/prop-chain-tracker.js";
import DictTrackerObjGen from "../../../prop-tracker-utils/dict-tracker-obj-gen.js";
import { Combiner } from "../../../prop-tracker-utils/combiner.js";

import ShallowObjectMerger from "../../../utils/shallow-object-merger.js";

import EnvLightTrackerLoader from "./envlights/envlight-tracker-loader.js";

const Types = ["env"];

class EnvLightLoading {
    constructor(evtCtx, shlWrapCtx, shlEvtCtx, envLightLoaders) {
        this._envDataTrackers = {};

        for (const type of Types) {
            this._envDataTrackers[type] = new PropChainTracker(evtCtx);
        }

        const envTrackLoaders = {
            "env": new EnvLightTrackerLoader(this._envDataTrackers["env"], evtCtx, envLightLoaders["env"], "env"),
        };

        const envGenByType = {};
        const merger = new Combiner((key) => new ShallowObjectMerger());

        for (const [i, type] of Types.entries()) {
            const envGen = new DictTrackerObjGen(shlWrapCtx, shlEvtCtx, envTrackLoaders[type]);
            envGenByType[type] = envGen;

            const mergeSource = new PropTracker();
            merger.setSource(i, mergeSource);
            mergeSource.track(envGen.data, envGen.events);
        }

        const mergeGen = new DictTrackerObjGen(shlWrapCtx, shlEvtCtx, merger);

        this._envLights = Object.freeze({
            byType: envGenByType,
            all: mergeGen,
        });
    }

    get envLights() { return this._envLights; }

    track(envLightDataByType) {
        if (envLightDataByType) {
            for (const type of Types) {
                this._envDataTrackers[type].track(envLightDataByType[type].data, ["value"]);
            }
        } else {
            for (const type of Types) {
                this._envDataTrackers[type].track();
            }
        }
    }

    update() {
        for (const type of Types) {
            this._envLights.byType[type].update();
        }

        this._envLights.all.update();
    }
}

export default EnvLightLoading;
